export const SET_RECENT_CHATS = 'SET_RECENT_CHATS';
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT';
export const SET_ACTIVE_CHAT_MESSAGES = 'SET_ACTIVE_CHAT_MESSAGES';
export const ADD_ACTIVE_CHAT_NEW_MESSAGE = 'ADD_ACTIVE_CHAT_NEW_MESSAGE';
export const UPDATE_ACTIVE_CHAT_MESSAGES = 'UPDATE_ACTIVE_CHAT_MESSAGES';
export const LEAVE_CHAT = 'LEAVE_CHAT';
export const JOIN_CHAT = 'JOIN_CHAT';
export const UPDATE_RECENT_CHATS = 'UPDATE_RECENT_CHATS';
export const SET_UNREAD_NUMBER = 'SET_UNREAD_NUMBER';
export const SET_REQUESTING_MESSAGES_CHAT_ID = 'SET_REQUESTING_MESSAGES_CHAT_ID';
export const READ_MESSAGE = 'READ_MESSAGE';
export const UPDATE_LAST_MESSAGE = 'UPDATE_LAST_MESSAGE';
export const UPDATE_USER_ACTIVITY = 'UPDATE_USER_ACTIVITY';
export const RESET_RECENT_CHATS = 'RESET_RECENT_CHATS';
export const SLICE_ACTIVE_CHAT_MESSAGES = 'SLICE_ACTIVE_CHAT_MESSAGES';
export const SET_USERS_NUMBER = 'SET_USERS_NUMBER';
export const MARK_ACTIVE_CHAT_AS_READ = 'MARK_ACTIVE_CHAT_AS_READ';
export const SET_RECONNECTION_ATTEMPTS = 'SET_RECONNECTION_ATTEMPTS';
export const SET_ACTIVE_CHAT_ID = 'SET_ACTIVE_CHAT_ID';
